<template>
  <div class="confirmation">
    <modal
      :name="name"
      :title="title"
    >
      <div class="confirmation-body">
        <p class="confirmation-text">
          <slot />
        </p>
        <div class="confirmation-buttons">
          <sh-button
            class="confirmation-confirm"
            :[btnLinkKey]="to"
            :fullWidth="$device.isMobile"
            :disabled="disabled || loading"
            :isLoading="loading"
            @click="onConfirm"
          >
            {{ confirm }}
          </sh-button>
          <sh-button
            :naked="true"
            :disabled="disabled || loading"
            @click="onCancel"
            >
              <span>{{ cancel }}</span>
          </sh-button>
        </div>
      </div>
      <template
        v-if="close"
        slot="close"
      >
        <ShIcon
          size="xsmall"
          name="close"
        />
      </template>
    </modal>
  </div>
</template>

<script>
import { ShIcon } from '@sohohouse/design-system'
import Modal from '~/components/modal/standard'
import { getButtonType } from '~/helpers/get-button-type'

export default {
  components: {
    ShIcon,
    Modal
  },

  props: {
    name: {
      type: String
    },
    title: {
      type: String,
      required: true
    },
    close: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: String,
      required: true
    },
    confirm: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    to: {
      type: String
    }
  },

  computed: {
    btnLinkKey () {
      return getButtonType(this.to)
    }
  },

  methods: {
    onCancel () {
      if (!this.disabled) {
        this.$emit('cancel')
      }
    },
    onConfirm () {
      if (!this.disabled) {
        this.$emit('confirm')
      }
    }
  }
}
</script>

<style lang="scss">

.confirmation {
  h2 {
    text-align: center;
  }
}

.confirmation-body {
  display: flex;
  flex-direction: column;
}

.confirmation-text {
  text-align: center;
  margin-bottom: $space-060;
}

.confirmation-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.confirmation-confirm {
  margin-bottom: $space-050;
}
</style>
